var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0B1181"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.614.21A1 1 0 0 0 .386 1.79L2.664 3.56c-.88.984-1.633 2.12-2.245 3.335l-.022.043c-.091.18-.21.413-.262.7a2.097 2.097 0 0 0 0 .723c.053.287.17.52.262.7l.022.042C2.359 12.956 5.719 16 10 16c2.231 0 4.213-.827 5.874-2.165l2.512 1.954a1 1 0 0 0 1.228-1.578l-18-14Zm12.627 12.355-1.798-1.398a4 4 0 0 1-6.115-4.756l-2.083-1.62c-.778.849-1.466 1.864-2.04 3.005a12.547 12.547 0 0 0-.1.204l.032.068.068.137C3.96 11.69 6.767 14 10 14c1.531 0 2.967-.518 4.241-1.434ZM8.02 7.726a2 2 0 0 0 2.735 2.127L8.019 7.727Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95 4.14 14 8.065V8a4 4 0 0 0-5.05-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.795 8.205a14.203 14.203 0 0 1-1.155 1.915l1.578 1.227a16.09 16.09 0 0 0 1.364-2.243l.021-.043c.092-.18.21-.412.262-.7a2.094 2.094 0 0 0 0-.723c-.052-.286-.17-.519-.262-.7l-.021-.042C17.642 3.044 14.28 0 10 0 8.285 0 6.717.489 5.33 1.323l1.729 1.345A6.889 6.889 0 0 1 10 2c3.233 0 6.04 2.31 7.795 5.796l.068.136.032.068a1.8 1.8 0 0 1-.032.068l-.068.137Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/HidePassword.5f4b0afcced75cbea57e856fb53e734e.svg";
export { ForwardRef as ReactComponent };